export const EDITION_FILTER_KEYS = [
    'sentEditions',
    'clickedEditions',
    'viewedEditions',
    'bouncedEditions',
    'unsubscribedEditions',
] as const;
